export default __webpack_public_path__ + "static/media/crossed-eye.ff01f740.svg";